<template>
  <div class="page-width-warpper">
    <div class="searchInfo" v-show="!!queryParams.title">
      已筛选标题：<el-tag closable @close="clearSearch">{{
        queryParams.title
      }}</el-tag>
    </div>
    <div class="news-warpper">
      <div class="left-warpper">
        <div
          style="width: 280px; height: 190px; margin-bottom: 15px"
          v-if="code === 'committee_information'"
        >
          <Wapper title="会展信息" :more="false">
            <ul class="category">
              <li
                v-for="(item, i) in categories"
                :key="i"
                :class="{ active: active === item.code }"
                @click="changeType(item.code)"
              >
                {{ item.name }}
              </li>
            </ul>
          </Wapper>
        </div>
        <div style="width: 280px">
          <Wapper :title="leftTitle" :more="false">
            <ul class="news">
              <li v-for="(item, i) in hotList" :key="i" @click="toDetail(item)">
                <p>{{ item.title }}</p>
              </li>
            </ul>
          </Wapper>
        </div>
      </div>
      <div style="flex: 1">
        <ul class="list">
          <li v-for="(item, i) in list" :key="i" @click="toDetail(item)">
            <!-- <div style="overflow: hidden; margin-right: 25px">
              <img class="image" :src="item.icon" />
            </div> -->
            <div class="info">
              <div>
                <div class="title">
                  <p>
                    {{ item.title }}
                  </p>
                </div>
                <!-- <div class="text">
                  {{ item.summary }}
                </div> -->
              </div>
              <span
                >时间：{{ item.createTime }} 点击：{{ item.cmsViewNum }}次</span
              >
            </div>
          </li>
        </ul>
        <div style="margin: 0 auto; max-width: 600px">
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Wapper from "./home/components/Wapper.vue";
import banner from "@/assets/images/banner/news.jpg";
import { getCodeByChild, pageByCode } from "@/api/index";

export default {
  name: "News",
  components: {
    Wapper,
  },
  props: {
    code: {
      type: String,
      default: "committee_information",
    },
    leftTitle: {
      type: String,
      default: "热点内容",
    },
  },
  data() {
    return {
      banner,
      list: [],
      hotList: [],
      categories: [],
      active: "",
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        // title: undefined,
      },
    };
  },
  // watch: {
  //   $route: {
  //     immediate: true,
  //     handler(val) {
  //       this.queryParams.title = val.query.title || "";
  //       this.getList();
  //     },
  //   },
  // },
  created() {
    if (this.code === "committee_information") {
      getCodeByChild({ code: this.code }).then((res) => {
        this.categories = res.data || [];
        this.active = this.categories[0].code;
        this.getList();
      });
      return;
    }
    this.getList();
  },
  methods: {
    clearSearch() {
      this.$router.replace(`/news`);
    },
    searchList() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    changeType(code) {
      if (this.active === code) return;
      this.active = code;
      console.log(this.active);
      this.searchList();
    },
    getList() {
      const params = {
        ...this.queryParams,
        code: this.active || this.code,
      };
      pageByCode(params).then((res) => {
        this.list = res.data && res.data.records;
        if (this.queryParams.pageNum === 1) {
          this.hotList = this.list;
        }
        this.total = res.data.total || 0;
      });
    },
    toDetail(item) {
      this.$router.push(
        `/newsDetail?id=${item.id}&code=${this.code}&title=${this.leftTitle}`
      );
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/variables.scss"; // global css
.news-warpper {
  display: flex;
  padding-bottom: 12px;
  .left-warpper {
    padding-top: 20px;
  }
  .category {
    width: 170px;
    margin-left: 14px;
    // margin-bottom: 40px;
    li {
      list-style: disc;
      position: relative;
      color: #999;
      font-size: 14px;
      padding-bottom: 36px;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
      &:last-child {
        &::before {
          height: 0;
        }
      }
      &.active {
        color: $main-color;
        font-size: 16px;
      }
      &::before {
        content: "";
        position: absolute;
        left: -14px;
        top: 15px;
        width: 1px;
        height: 100%;
        background: #d8d9dd;
      }
    }
  }
  .news {
    margin-top: 6px;
    li {
      display: flex;
      justify-content: space-between;
      line-height: 24px;
      font-size: 14px;
      position: relative;
      padding-left: 10px;
      &::before {
        content: "";
        position: absolute;
        left: 2px;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 3px;
        border-radius: 50%;
        background: #555;
      }
      p {
        flex: 1;
        color: #555;
        cursor: pointer;
        @include clamp(1);
        &:hover {
          color: $main-color;
          text-decoration: underline;
        }
      }
      span {
        color: #888;
        margin-left: 10px;
      }
    }
  }
  .list {
    margin-left: 12px;
    margin-top: 20px;
    border: 1px solid #eee;
    li {
      display: flex;
      cursor: pointer;
      padding: 10px 15px;
      // border-bottom: 1px solid #eee;
      background: #f2f2f2;
      &:nth-child(2n + 1) {
        background: #fff;
      }
      &:hover {
        .image {
          transform: scale(1.2);
        }
        .title {
          P {
            text-decoration: underline;
          }
        }
      }
      .image {
        width: 196px;
        height: 130px;
        object-fit: cover;
        border-radius: 2px;
        transition: 0.5s all;
      }
      .info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-bottom: 30px;
      }
      .title {
        display: flex;
        line-height: 30px;
        p {
          font-size: 16px;
          color: $main-color;
          flex: 1;
          @include clamp(2);
        }
      }
      .text {
        display: none;
        // margin-top: 10px;
        line-height: 1.6;
        font-size: 14px;
        color: #666;
        @include clamp(3);
      }
      span {
        margin-top: 5px;
        font-size: 12px;
        color: #999;
      }
    }
  }
}
</style>
